
import { mixins } from 'vue-class-component';
import { Component, Vue } from 'vue-property-decorator';
import OauthMixin from '@/mixins/http/OauthMixin';

@Component
export default class OauthStart extends mixins(OauthMixin) {
  async created() {
    await this.startOauth();
  }

  render() {
    return null;
  }
}
